import * as React from 'react';
import {
  OutlinedInput,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Checkbox,
  ListSubheader,
  TextField,
  Box,
  Typography,
  Tooltip,
  Avatar,
} from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 300,
    },
  },
  disableAutoFocusItem: true,
};

const getInitials = (fullName) => {
  const parts = fullName.trim().split(' ');
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

function TruncatedTooltip({ children }) {
  const textRef = React.useRef(null);
  const [isTruncated, setIsTruncated] = React.useState(false);

  React.useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [children]);

  return isTruncated ? (
    <Tooltip title={children}>
      <Typography
        ref={textRef}
        noWrap
        sx={{
          maxWidth: '160px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontSize: '14px',
          color: '#111',
          cursor: 'default',
        }}
      >
        {children}
      </Typography>
    </Tooltip>
  ) : (
    <Typography
      ref={textRef}
      noWrap
      sx={{
        maxWidth: '160px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: '14px',
        color: '#111',
      }}
    >
      {children}
    </Typography>
  );
}
export default function SingalUserImageSelect({
  label = 'Select User',
  options = [],
  selectedValue = '',
  onChange = () => { },
}) {
  const [searchTerm, setSearchTerm] = React.useState('');

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  const filteredOptions = options.filter((opt) =>
    opt.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const selectedOption = options.find((opt) => opt.name === selectedValue);

  return (
    <FormControl sx={{ m: 0, width: { xl: '240px', lg: '190px', md: '190px', sm: '190px' } }}>
      <InputLabel id={`${label}-label`} sx={{
        top: '-7px',
        fontSize: '14px',
        // Target when label is focused
        '&.Mui-focused': {
          top: '0px',
          fontSize: { xl: '16px', lg: '13px', md: '13px', sm: '13px', xs: '13px' },
        },
        // Target when input is filled (label shrinks)
        '&.MuiFormLabel-filled': {
          top: '0px',
          fontSize: { xl: '16px', lg: '13px', md: '13px', sm: '13px', xs: '13px' },
        },
      }}>{label}</InputLabel>
      <Select
        MenuProps={MenuProps}
        labelId={`${label}-label`}
        id={`${label}-select`}
        value={selectedValue}
        IconComponent={KeyboardArrowDown}
        onChange={handleChange}
        input={<OutlinedInput label={label} sx={{
          height: 38,
          borderRadius: '50px',
          paddingRight: '32px',
          display: 'flex',
          alignItems: 'center',
        }} />}
        renderValue={() =>
          selectedOption ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {selectedOption.image ? (
                <Avatar
                  src={selectedOption.image}
                  alt={selectedOption.name}
                  sx={{ width: 28, height: 28 }}
                />
              ) : (
                <Avatar
                  sx={{
                    width: 28,
                    height: 28,
                    backgroundColor: '#1976d2',
                    fontSize: 12,
                    fontWeight: 600,
                  }}
                >
                  {getInitials(selectedOption.name)}
                </Avatar>
              )}
              <Typography sx={{ fontSize: '14px' }}>{selectedOption.name}</Typography>
            </Box>
          ) : (
            <Typography >Select User</Typography>
          )
        }

        // MenuProps={MenuProps}
        sx={{
          background: '#fff',
          borderRadius: '50px',
          '& .MuiSelect-select': {
            paddingTop: '8px',
            paddingBottom: '7px',
            height: 23,
            fontSize: '12px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderRadius: '50px',
          },
          '& .MuiSelect-icon': {
            color: '#64748B',
            right: '8px',
          },
        }}
      >
        <ListSubheader>
          <Box
            disableRipple
            disableTouchRipple
            sx={{
              position: 'sticky',
              // padding: '10px 0px',
              top: 0,
              zIndex: 999,
              background: '#fff !important',
            }}
          >
            <TextField
              className="clsinpfields"
              sx={{
                background: '#fff',
                '& .MuiInputBase-input': {
                  fontSize: '13px',
                },
              }}
              fullWidth
              size="small"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
              onMouseDown={(e) => {
                e.stopPropagation();
              }}
            />
          </Box>
        </ListSubheader>


        {filteredOptions.map((opt) => (
          <MenuItem key={opt.name} value={opt.name}>
            {opt.image ? (
              <Avatar
                src={opt.image}
                alt={opt.name}
                sx={{ width: 30, height: 30, mr: 1 }}
              />
            ) : (
              <Avatar
                sx={{
                  width: 30,
                  height: 30,
                  backgroundColor: '#1976d2',
                  fontSize: 12,
                  fontWeight: 600,
                  mr: 1,
                }}
              >
                {getInitials(opt.name)}
              </Avatar>
            )}
            <TruncatedTooltip>{opt.name}</TruncatedTooltip>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
